'use strict';

const descriptionAscending = (a, b) => {
		const descA = (a && a.description && a.description.toUpperCase()) || '',
			descB = (b && b.description && b.description.toUpperCase()) || '';
		if (descA < descB) {
			return -1;
		}
		if (descA > descB) {
			return 1;
		}
		return -1;
	},
	invert = (f) => {
		return (a, b) => f(b, a);
	},
	lastModifiedAscending = (a, b) => {
		const tsA = (a && a.lastModified) || 0,
			tsB = (b && b.lastModified) || 0;
		if (tsA > tsB) {
			return 1;
		}
		return -1;
	},
	sorts = {
		descriptionAscending: descriptionAscending,
		descriptionDescending: invert(descriptionAscending),
		lastModifiedAscending: lastModifiedAscending,
		lastModifiedDescending: invert(lastModifiedAscending)
	},
	defaultComparison = descriptionAscending;


module.exports = function goldFileSort(list, sortName) {
	if (!list) {
		return [];
	}
	const toSort = Array.from(list),
		comparison = sorts[sortName] || defaultComparison;

	return toSort.sort(comparison);
};
